import { ProcedureStepAssigneeService as OvermapProcedureStepAssigneeService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureStepAssigneeService extends OvermapProcedureStepAssigneeService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
